import { theme } from '../../../../styles/theme';
import { ContainerLegalRepresentative } from './RepresentativesCard.styles';
import {
  OptionsContainer,
  LoadingContainer,
  ButtonContainer,
  SmallerModal,
} from '../../styles/GerenciarClientes.styles';
import {
  removeLegalRepresentative,
  editLegalRepresentative,
} from '../../../../store/fetchActions/usersActions';
import verifyEmptyValues from '../../../../utils/verifyEmptyValues';
import formatPhoneNumber from '../../../../utils/functions/formatPhoneNumber';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import formatCPF from '../../../../utils/functions/formatCPF';
import Modal from '../../../../components/Modal/Modal';
import ModalPassword from '../../../../components/ModalPassword/ModalPassword';
import Button from '../../../../components/Button/Button';
import MaskField from '../../../../components/MaskField/MaskField';
import TextInput from '../../../../components/TextInput/TextInput';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { MdErrorOutline } from 'react-icons/md';
import removeSpecialChars from '../../../../utils/functions/removeSpecialChars';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

const {
  mainColor,
  rbmWhite,
  rbmBlack,
  secondaryColor,
  dangerColor,
  warningColor,
} = theme.colors;

const LegalRepresentative = () => {
  const dispatch = useDispatch();

  const { legalRepresentativesLoading, legalRepresentativesData, usersData } =
    useSelector((state) => state.user);

  useEffect(() => {
    initializeIsEditable();
  }, []);

  const initializeIsEditable = () => {
    isEditable.length = 0;
    for (var i = 0; i < legalRepresentativesData?.length; i++) {
      isEditable.push({ id: i, value: false });
      setIsEditable([...isEditable]);
    }
  };

  const [isEditable, setIsEditable] = useState([]);
  const [myIndex, setMyIndex] = useState('');
  const [representativeCPF, setRepresentativeCPF] = useState('');
  const [representativeCNPJ, setRepresentativeCNPJ] = useState('');
  const [buttonClicked, setButtonClicked] = useState('');
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [
    isModalRemoveLegalRepresentantiveOpen,
    setIsModalRemoveLegalRepresentantiveOpen,
  ] = useState(false);

  const openModalPassword = () => setIsModalPasswordOpen(true);
  const closeModalPassword = () => setIsModalPasswordOpen(false);

  const removeLegalRepresentativeById = (selectedId) => {
    setSelectedId(selectedId);
    openModalPassword();
  };

  const closeModals = () => {
    closeModalRemoveLegalRepresentative();
    initializeIsEditable();
  };

  const changeIsEditable = (index) => {
    reset();
    let arrayCopy = [...isEditable];
    arrayCopy[index].value = !arrayCopy[index].value;
    setIsEditable(arrayCopy);
  };

  const closeModalRemoveLegalRepresentative = () =>
    setIsModalRemoveLegalRepresentantiveOpen(false);
  const openModalRemoveLegalRepresentative = () =>
    setIsModalRemoveLegalRepresentantiveOpen(true);

  const formatOption = (value) => {
    const options = {
      N: 'Não',
      S: 'Sim',
    };

    return options[value];
  };

  const { handleSubmit, control, reset } = useForm({});

  if (legalRepresentativesLoading) {
    return (
      <LoadingContainer marginTop={'1vw'}>
        <CircularProgress size={'5vw'} color="inherit" />
      </LoadingContainer>
    );
  }

  const editRepresentative = (data) => {
    let param = {
      REPRESENTANTES: [
        {
          ...data,
          ID: selectedId,
          CELULAR: removeSpecialChars(['(', ')', ' ', '-'], data.CELULAR),
          CPF: removeSpecialChars(['.', '-', '/'], representativeCPF),
          CNPJ_EMPRESA: removeSpecialChars(['.', '-', '/'], representativeCNPJ),
        },
      ],
    };
    dispatch(
      editLegalRepresentative(
        param,
        usersData?.CPFCNPJ,
        closeModals,
        'wontBeLoaded'
      )
    );
  };

  return (
    <ContainerLegalRepresentative>
      {legalRepresentativesData?.length > 0 && <h2>Representantes Legais</h2>}
      <div>
        {legalRepresentativesData?.map((representative, index) => {
          return (
            <div className="card" key={index}>
              <form onSubmit={handleSubmit(editRepresentative)}>
                <div className="box-legal-representative-data">
                  <p className="box-legal-representative-title-data">Nome:</p>
                  {isEditable[index]?.value ? (
                    <TextInput
                      label="Nome"
                      name={'NOME'}
                      value={representative?.NOME}
                      initialValue={representative?.NOME}
                      width={'22.042vw'}
                      margin={'0 0 0 1.369vw'}
                      control={control}
                    />
                  ) : (
                    <p>{verifyEmptyValues(representative?.NOME)}</p>
                  )}
                </div>
                <div className="box-legal-representative-data">
                  <p className="box-legal-representative-title-data">
                    Celular:
                  </p>
                  {isEditable[index]?.value ? (
                    <MaskField
                      label="Celular"
                      name={'CELULAR'}
                      value={formatPhoneNumber(representative?.CELULAR)}
                      initialValue={formatPhoneNumber(representative?.CELULAR)}
                      mask={'(99) 99999-9999'}
                      width={'22.042vw'}
                      control={control}
                    />
                  ) : (
                    <p>
                      {verifyEmptyValues(
                        formatPhoneNumber(representative?.CELULAR)
                      )}
                    </p>
                  )}
                </div>
                <div className="box-legal-representative-data">
                  <p className="box-legal-representative-title-data">CPF:</p>

                  <p>{verifyEmptyValues(formatCPF(representative?.CPF))}</p>
                </div>
                <div className="box-legal-representative-data">
                  <p className="box-legal-representative-title-data">
                    CNPJ da Empresa:
                  </p>

                  <p>
                    {verifyEmptyValues(
                      formatCNPJ(representative?.CNPJ_EMPRESA)
                    )}
                  </p>
                </div>
                <div className="box-legal-representative-data-last">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={representative?.PRINCIPAL === 'S'}
                          name="radio-buttons"
                          disabled
                        />
                      }
                      label="Representante legal principal"
                      sx={{
                        fontStyle: '12px',
                      }}
                    />
                  </RadioGroup>
                </div>
              </form>
            </div>
          );
        })}
      </div>

      <ModalPassword
        openModal={isModalPasswordOpen}
        closeModal={closeModalPassword}
        nextFunction={
          buttonClicked === 'EDITAR'
            ? () => changeIsEditable(myIndex)
            : openModalRemoveLegalRepresentative
        }
      />

      <Modal
        open={isModalRemoveLegalRepresentantiveOpen}
        close={closeModalRemoveLegalRepresentative}
      >
        <SmallerModal>
          <MdErrorOutline color={warningColor} size={'6.944vw'} />
          <h3>Excluir Representante Legal</h3>
          <h5>Tem certeza que deseja excluir o representante legal?</h5>
          <ButtonContainer>
            <Button
              backgroundColor={rbmWhite}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={secondaryColor}
              hoverColor={rbmWhite}
              color={secondaryColor}
              onClick={() => {
                closeModalRemoveLegalRepresentative();
              }}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundColor={secondaryColor}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverBGColor={dangerColor}
              hoverColor={rbmWhite}
              color={rbmWhite}
              roleName="button-confirm-deletion-representative-legal"
              onClick={() =>
                dispatch(
                  removeLegalRepresentative(
                    selectedId,
                    usersData?.CPFCNPJ,
                    closeModals,
                    'wontBeLoaded'
                  )
                )
              }
            >
              <span>Remover</span>
            </Button>
          </ButtonContainer>
        </SmallerModal>
      </Modal>
    </ContainerLegalRepresentative>
  );
};

export default LegalRepresentative;
